"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const input_checkbox_1 = require("../../components/input/input.checkbox");
const tag_icon_style_1 = require("../tag.icon/tag.icon.style");
exports.CSS = {
    container: 'c-TagCardCheckbox',
    hasSelections: 'c-TagCardCheckbox__has-selections',
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex',
        alignItems: 'center',
    },
    [`${exports.CSS.container} .${input_checkbox_1.CSS.container}`]: {
        display: 'none',
        width: 'inherit',
        height: 'inherit',
    },
    [`${exports.CSS.container}:hover .${tag_icon_style_1.CSS.container}`]: {
        display: 'none',
    },
    [`${exports.CSS.container}:hover .${input_checkbox_1.CSS.container}`]: {
        display: 'flex',
    },
    [`${exports.CSS.container}.${exports.CSS.hasSelections} .${input_checkbox_1.CSS.container}`]: {
        display: 'flex',
    },
};
//# sourceMappingURL=tag.card.checkbox.style.js.map